import {
  AviaAnimalRescueJiabaoRoute,
  AviaPetAdoptionTangtangRoute,
  NewsRoute,
  SolitaireClashMomsWeekWithLoveRoute,
  SolitaireHorizontalMoveRoute,
  SolitaireMovesCardsRoute,
  SolitaireTermsExplainedRoute,
  SolitaireUndoTrickRoute,
  ThisSimpleSolitaireGaveMeMoreRoute,
} from '../news'
import { generateMetadata, MetaDataEntity } from './utils'

const MetaData: MetaDataEntity = {
  title: 'AviaGames | Game News & Updates',
  description:
    "Stay updated with the latest game news from Avia! Get updates on new features, seasonal events, and more. Don't miss out on exciting game announcements!",
  keywords: ['game news'],
  path: NewsRoute,
}

export const NewsMetaData = generateMetadata(MetaData)

export const SolitaireTermsExplainedMetaData = generateMetadata({
  title: 'Solitaire Clash Guide 101: Master Solitaire Card Game Terms',
  description:
    'New to Solitaire Clash? This guide breaks down essential solitaire card game terms so you can play with confidence and sharpen your strategy.',
  keywords: [],
  path: SolitaireTermsExplainedRoute,
})

export const SolitaireUndoTrickMetaData = generateMetadata({
  title: 'How to Use Undo Like a Pro in Solitaire Clash (Simple 4-Step Trick)',
  description:
    'Learn how to use the undo feature in Solitaire to reveal hidden cards, make better decisions, and boost your opportunities of winning.',
  keywords: [],
  path: SolitaireUndoTrickRoute,
})

export const SolitaireMovesCardsMetaData = generateMetadata({
  title: 'How to Win Solitaire Clash with One Simple Move',
  description:
    'Stuck in Solitaire Clash? Learn how moving cards down from the foundation can unlock winning moves. Master smart strategies to improve your solitaire gameplay.',
  keywords: [],
  path: SolitaireMovesCardsRoute,
})

export const SolitaireHorizontalMoveMetaData = generateMetadata({
  title: 'Solitaire Clash Strategy: Unlock Hidden Cards with the Horizontal Move',
  description:
    'Unlock hidden cards and boost your win rate with a smart solitaire strategy. Try this simple horizontal move in Solitaire Clash and play like a pro.',
  keywords: [],
  path: SolitaireHorizontalMoveRoute,
})

export const ThisSimpleSolitaireGaveMeMoreMetaData = generateMetadata({
  title: 'Play Simple Solitaire in Minutes with Solitaire Clash',
  description:
    'Play simple solitaire anytime with Solitaire Clash—fast, fun, and easy to start. Perfect for quick breaks or relaxing moments on the go!',
  keywords: [],
  path: ThisSimpleSolitaireGaveMeMoreRoute,
})

export const SolitaireClashMomsWeekWithLoveMetaData = generateMetadata({
  title: 'Solitaire Clash Mom’s Week Recap – Mother’s Day 2025 Campaign Highlights',
  description:
    'Discover how Solitaire Clash celebrated Mother’s Day 2025 with its first integrated brand campaign, Mom’s Week. See key moments, livestream highlights, and community impact.',
  keywords: [],
  path: SolitaireClashMomsWeekWithLoveRoute,
})

export const AviaPetAdoptionTangtangMetaData = generateMetadata({
  title: 'Tangtang’s Journey: A Heartwarming Pet Adoption Story at Avia',
  description:
    'Discover Tangtang’s inspiring pet adoption story—from a frail kitten rescued in Tangshan to Avia’s beloved office cat. Learn how our “Office Cat” initiative brings warmth and compassion to our workplace.',
  keywords: [],
  path: AviaPetAdoptionTangtangRoute,
})

export const AviaAnimalRescueJiabaoMetaData = generateMetadata({
  title: "Avia's Office Cat: Jiabao's Animal Rescue Journey",
  description:
    'Discover Jiabao’s inspiring animal rescue journey, from a struggling stray to Avia’s beloved office cat, bringing comfort and connection to our team.',
  keywords: [],
  path: AviaAnimalRescueJiabaoRoute,
})
